function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
// If it has `attributes` then it's a fetch request
var isErrorEntry = function(res) {
    if ("success" in res && res.success) {
        return true;
    } else {
        return false;
    }
};
export var raiseSfError = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(p) {
        var res, errGraph, ref, error, hasError, errorRes;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return p;
                case 2:
                    res = _ctx.sent;
                    if (!("graphs" in res)) {
                        _ctx.next = 11;
                        break;
                    }
                    errGraph = res.graphs.find(function(v) {
                        return !v.isSuccessful;
                    });
                    if (!errGraph) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    error = (ref = errGraph.graphResponse.compositeResponse.find(function(resEntry) {
                        return resEntry.body[0] && resEntry.body[0].message !== "The transaction was rolled back since another operation in the same transaction failed.";
                    })) === null || ref === void 0 ? void 0 : ref.body[0];
                    throw new Error(error === null || error === void 0 ? void 0 : error.message);
                case 9:
                    _ctx.next = 16;
                    break;
                case 11:
                    hasError = Array.isArray(res) ? res.some(function(v) {
                        return isErrorEntry(v);
                    }) : isErrorEntry(res);
                    if (!hasError) {
                        _ctx.next = 16;
                        break;
                    }
                    errorRes = Array.isArray(res) ? res.find(function(v) {
                        if (!v.success) {
                            var ref;
                            return (ref = v.errors) === null || ref === void 0 ? void 0 : ref.length;
                        } else {
                            return false;
                        }
                    }) : res;
                    if (!(errorRes && !errorRes.success)) {
                        _ctx.next = 16;
                        break;
                    }
                    throw new Error(errorRes.errors[0].message);
                case 16:
                    return _ctx.abrupt("return", res);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function raiseSfError(p) {
        return _ref.apply(this, arguments);
    };
}();
export default raiseSfError;
